export class FeatureSetting {
  Id: string;
  Value: string;
  DataType: string;
  Environment: string;
  Modified: string;
  constructor(opt?: Partial<FeatureSetting>) {
    Object.assign(this, opt);
  }
}
